module.exports = __webpack_public_path__ + "static/img/1.458efce.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/sp/1.png
// module id = 2fQ0
// module chunks = 0